export default __webpack_public_path__ + "static/media/eventAvailable.a2e7f2f0.svg";